import React from "react";
import { cn } from "@/utils/utils";

export interface ScrollAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const ScrollArea = ({ children, className, ...props }: ScrollAreaProps) => {
  return (
    <div className={cn("h-full overflow-auto", className)} {...props}>
      {children}
    </div>
  );
};
